import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Scan from "@/pages/Scan";
import FreeResults from "@/pages/FreeResults";
import PaidResults from "@/pages/PaidResults";
import Insights from "@/pages/Insights";
import Videos from "@/pages/Videos";
import Tools from "@/pages/Tools";
import Newsletter from "@/pages/Newsletter";
import About from "@/pages/About";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Disclaimer from "@/pages/Disclaimer";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/scan" element={<Scan />} />
          <Route path="/results/free/:resultId" element={<FreeResults />} />
          <Route path="/results/free" element={<FreeResults />} />
          <Route path="/results/paid/:resultId" element={<PaidResults />} />
          <Route path="/results/paid" element={<PaidResults />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/about" element={<About />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
